import React from 'react';
import { SlideLayout } from '../components/SlideLayout';
import { Button } from '../components/Button';
import { ArrowRight } from 'lucide-react';
interface Slide1Props {
  onNext: () => void;
}
export function Slide1({
  onNext
}: Slide1Props) {
  return <SlideLayout footer="¹ Vabysmo® Summary of Product Characteristics (SmPC/RCP), May 2024." data-id="element-31">
      <div className="w-full max-w-7xl mx-auto grid grid-cols-5 gap-16 items-center" data-id="element-32">
        <div className="col-span-3 space-y-8" data-id="element-33">
          <h1 className="text-4xl font-bold text-primary" data-id="element-34">
            The first and only bispecific antibody targeting VEGF-A and Ang-2
            <sup data-id="element-35">¹</sup>
          </h1>
          <p className="text-lg text-gray-600 leading-relaxed" data-id="element-36">
            Designed to address two key pathways involved in retinal vascular
            instability.
          </p>
          <div className="pt-4" data-id="element-37">
            <Button variant="primary" onClick={onNext} data-id="element-38">
              See the dual-target approach
              <ArrowRight className="w-5 h-5" data-id="element-39" />
            </Button>
          </div>
        </div>
        <div className="col-span-2 flex items-center justify-center" data-id="element-40">
          <div className="relative p-1 rounded-3xl bg-gradient-to-br from-[#1B3A5C] via-[#0E8585] to-[#3DA06D]" data-id="element-41">
            <div className="bg-white rounded-3xl p-4" data-id="element-42">
              <img src="https://cdn.magicpatterns.com/uploads/tm2Ze3Cc3HAunRqoVV2W7P/Screenshot_2026-02-16_at_17.56.01.png" alt="Bispecific antibody targeting VEGF-A and Anti-Ang-2" className="w-full h-auto rounded-2xl shadow-lg" data-id="element-43" />
            </div>
          </div>
        </div>
      </div>
    </SlideLayout>;
}